import styled from 'styled-components';

export const WrapperFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  .before-version {
    height: 20px;
    width: 20px;
    border-radius: 50%;
    margin: 10px;
    background-color: orange;
  }
  .after-version {
    height: 20px;
    width: 20px;
    border-radius: 50%;
    margin: 10px;
    background-color: green;
  }
`;

export const ButtonFooter = styled.button`
  display: flex;
`;
